<div class="table-content" *ngIf="exibirDetalhes == false">
  <div class="container-fluid mt-2">
    <p-panel header="Carregar Arquivo" styleClass="p-shadow-3">
      <p-fileUpload *ngIf="!progress" #fileUploader mode="advanced" name="myfile[]" customUpload="true"
        [multiple]="true" accept=".csv" (uploadHandler)="onUpload($event)" (onSelect)="onSelectFile($event)"
        (onProgress)="progressReport($event)" (onRemove)="onRemoveFile($event)" (onClear)="onRemoveFile()"
        chooseLabel="Arquivo" uploadLabel="Enviar" (onError)="onErrorUpload($event)" cancelLabel="Cancelar"
        invalidFileSizeMessageSummary="Tamanho Invalido"
        invalidFileSizeMessageDetail="Tamanho do arquivo enviado é invalido."
        invalidFileTypeMessageSummary="Arquivo não suportado!"
        invalidFileTypeMessageDetail="O arquivo suportado é: .csv">
        <ng-template let-file pTemplate='file'>
          <div class="container file-item">
            <div class="row">
              <div class="col col-sm d-flex align-items-center ml-3">
                <div>{{file.name}} - {{file.size | filesize}}</div>
              </div>
              <div class="col col-sm align-items-center">
                <div>
                  <button class="float-right mr-3" icon="pi pi-times" pButton type="button"
                    (click)="removeFile(file , fileUploader)">
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </p-fileUpload>
      <p-progressBar *ngIf="!progress" [value]="progressBarPerc"></p-progressBar>
    </p-panel>
  </div>
  <div class="container-fluid mt-2">
    <p-toast key="carga" position="bottom-right"></p-toast>
    <p-card styleClass="p-shadow-3">
      <p-table #myTab styleClass="p-datatable-sm " styleClass="p-shadow-3" [tableStyle]="{'min-width': '50rem'}"
        [globalFilterFields]="['nome', 'usuario', 'statusString', 'data', 'diferencaHorario']" [loading]="loading"
        columnResizeMode="expand" [value]="listaUpload" [paginator]="true" [rows]="10" [showCurrentPageReport]="true"
        currentPageReportTemplate="Mostrando {first} à {last} de {totalRecords} registro(s)"
        [rowsPerPageOptions]="[10,20,30,50,100]" [autoLayout]="true" sortMode="multiple"
        paginatorDropdownAppendTo="body">
        <ng-template pTemplate="caption">
          <div style="display:flex;">
            <div class="divConfigurar">
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input placeholder="Pesquisar" class="p-inputtext-sm ml-auto" type="text"
                  (input)="myTab.filterGlobal($any($event.target).value, 'contains')" pInputText>
              </span>
            </div>
            <div class="col-md col-sm pl-1 pr-1 filter-margin" style="display: inline-flex;justify-content: flex-end;">
              <button pButton label="" pTooltip="Atualizar Status" icon="pi pi-refresh" (click)="recarregarDados()"
                class="p-button-sm p-button-secondary p-button-mobile">
              </button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="nome" style="width:20% ;">Arquivo<p-sortIcon field="nome"></p-sortIcon>
            </th>
            <th pSortableColumn="data" pSortField="data">Data<p-sortIcon field="data"></p-sortIcon>
            </th>
            <th pSortableColumn="diferencaHorario">Duração<p-sortIcon field="diferencaHorario"></p-sortIcon>
            </th>
            <th pSortableColumn="usuario">Usuário<p-sortIcon field="usuario"></p-sortIcon>
            </th>
            <th pSortableColumn="status">Status
            </th>
            <th style="width:10%">Detalhes
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <a href="#" (click)="baixarArquivo($event, item.nome)"> {{item.nome}} </a>
            </td>
            <td>
              {{item.dataConvertida}}
            </td>
            <td pTooltip="{{item.horaFimProcessamento}} - {{item.horaInicioProcessamento}}" tooltipPosition="top">

              {{item.diferencaHorario}}

            </td>
            <td>
              {{item.usuario}}
            </td>
            <td>
              <p-badge *ngIf="item.statusString == 'Pendente'" value="Pendente" severity="info"></p-badge>
              <p-badge *ngIf="item.statusString == 'Sucesso'" value="Sucesso" severity="success"></p-badge>
              <p-badge *ngIf="item.statusString == 'Processando'" value="Processando" severity="info"></p-badge>
              <p-badge *ngIf="item.statusString == 'Erro'" value="Erro" severity="danger"></p-badge>
              <p-badge *ngIf="item.statusString == 'Pendente p/ Validação'" value="Pendente p/ Validação"
                severity="warning"></p-badge>
            </td>
            <td>
              <button class="btn-detail" type="button" (click)="mostrarDetalhes(item)">
                <img class="img-detail" src="/assets/img/detail.png" alt="Detalhes">
              </button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>

</div>


<div class="container-fluid mt-2" *ngIf="exibirDetalhes">
  <button class="close-button" pButton type="button" label="Voltar" (click)="fecharDetalhes()"
    style="width: 75px; height: 25px; position: left; margin-bottom: 8px;"></button>
  <div style="justify-content: center;">
    <p-tabView>
      <p-tabPanel header="Resultado do Processamento">
        <p-panel styleClass="p-shadow-3">
          <ng-template pTemplate="header">
            <div>
              <h4> Resultado do Processamento</h4>
            </div>
          </ng-template>
          <ng-template pTemplate="body">
            <div *ngIf="arquivoStatus === 0" style="border-radius: 10px; font-size: 20px;">
              <label
                style="color: rgb(50, 91, 206); font-weight: bold; font-size: 49px;text-shadow: 0.25px 1.25px 0.25px gray;">Pendente</label>
            </div>
            <div *ngIf="arquivoStatus === 1" style="border-radius: 10px; font-size: 20px;">
              <label
                style="color: rgb(39, 177, 39); font-weight: bold; font-size: 49px;text-shadow: 0.25px 1.25px 0.25px gray;">Sucesso</label>
            </div>
            <div *ngIf="arquivoStatus === 2" style="border-radius: 10px; font-size: 20px;">
              <label
                style="color: rgb(39, 177, 39); font-weight: bold; font-size: 49px;text-shadow: 0.25px 1.25px 0.25px gray;">Processado</label>
            </div>
            <div *ngIf="arquivoStatus === 3" style="border-radius: 10px;font-size: 20px;">
              <label
                style="color: red; font-weight: bold;font-size: 49px;text-shadow: 0.25px 1.25px 0.25px gray;">Erro</label>
            </div>

          </ng-template>
        </p-panel>
        <div style="
        margin-top: 10px;">
          <p-panel header="Informação do Processamento:" [toggleable]="true" styleClass="p-shadow-3">
            <div *ngFor="let msg of statusMsg" style="white-space: pre-line;">{{msg}}</div>
          </p-panel>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Listagem Dealers">
        <p-table #myTab styleClass="p-datatable-sm " styleClass="p-shadow-3" [tableStyle]="{'min-width': '50rem'}"
          [globalFilterFields]="['id', 'nome', 'status', 'codigo']" columnResizeMode="expand" [value]="infoCargaList"
          [paginator]="true" [rows]="10">
          <ng-template pTemplate="caption">
            <div class="divConfigurar " style="
            display: flex;
            justify-content: space-between;">
              <h4>Resultado da Distribuição aos Dealers</h4>
              <span class="p-input-icon-right">
                <i class="pi pi-search"></i>
                <input placeholder="Pesquisar" class="p-inputtext-sm ml-auto" type="text"
                  (input)="myTab.filterGlobal($any($event.target).value, 'contains')" pInputText>
              </span>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon>
              </th>
              <th pSortableColumn="id">Dealer <p-sortIcon field="id"></p-sortIcon>
              </th>
              <th pSortableColumn="qtdSucesso">Qtd. Sucesso<p-sortIcon field="qtdSucesso"></p-sortIcon>
              </th>
              <th pSortableColumn="qtdFalha">Qtd. Falha<p-sortIcon field="qtdFalha"></p-sortIcon>
              </th>
              <th pSortableColumn="status">Status<p-sortIcon field="status"></p-sortIcon>
              </th>
              <th pSortableColumn="dataProcessamento">Data Processamento<p-sortIcon
                  field="dataProcessamento"></p-sortIcon>
              </th>
              <th pSortableColumn="versaoPlugin">Versão Plugin<p-sortIcon field="versaoPlugin"></p-sortIcon>
              </th>
              <th pSortableColumn="qtdRegistro">Qtd. Registro<p-sortIcon field="qtdRegistro"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <td>
                {{item.nome}}
              </td>
              <td>
                {{item.codigo}}
              </td>
              <td>
                {{item.qtdSucesso}}
              </td>
              <td>
                {{item.qtdFalha}}
              </td>
              <td>
                <p-badge [value]="item.processado === true ? 'Processado' : 'Pendente'"
                  [severity]="item.processado === true ? 'success' : 'info'"></p-badge>
              </td>
              <td>
                {{ item.dataProcessamento | date:'dd/MM/yyyy HH:mm:ss' }}
              </td>
              <td>
                {{item.versaoPlugin}}
              </td>
              <td>
                {{item.qtdRegistro}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
    </p-tabView>
  </div>

</div>

<p-dialog
  header="Falha na importação do arquivo"
  [(visible)]="exibirDialogErro"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '760px'}"
  (onHide)="fecharDialogErro()">

  <div style="margin-bottom: 10px; font-weight: bold;">
    {{ erroTitulo }}
  </div>

  <div style="
      white-space: pre-wrap;
      font-family: 'Courier New', monospace;
      font-size: 0.85rem;
      max-height: 420px;
      overflow-y: auto;
      background-color: #f8f9fa;
      border: 1px solid #dee2e6;
      border-radius: 4px;
      padding: 12px;">{{ erroDetalhado }}</div>

  <div style="margin-top: 12px; font-size: 0.85rem; color: #6c757d;">
    Nenhuma linha foi gravada. Corrija os itens acima e envie o arquivo novamente.
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" icon="pi pi-copy" label="Copiar lista"
      class="p-button-outlined p-button-secondary p-button-sm"
      (click)="copiarErro()"></button>
    <button pButton type="button" label="Fechar"
      class="p-button-sm"
      (click)="fecharDialogErro()"></button>
  </ng-template>
</p-dialog>